export const MBC_CHAT_API =
  import.meta.env.VITE_MBC_MASTRA_CHAT_URL ?? "/api/ai/v1/chat/mbcAgent";

/**
 * Base URL for the Mastra REST API, used to read back working memory
 * (the brief form). Origin-relative so the browser sends the httpOnly JWT
 * cookie automatically (same-origin behind CloudFront/ALB); proxied through
 * Vite to the Mastra server (:4111) in local dev.
 */
export const MBC_MASTRA_API_URL =
  import.meta.env.VITE_MBC_MASTRA_API_URL ?? "/api/ai/v1";
